var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99957 24.5H29.9996V8H5.99957V24.5ZM19.4996 27.5V30.5H25.4996V33.5H10.4996V30.5H16.4996V27.5H4.48757C4.2906 27.4988 4.0958 27.4588 3.91433 27.3822C3.73286 27.3056 3.56829 27.1939 3.43006 27.0536C3.29183 26.9133 3.18265 26.747 3.10877 26.5644C3.0349 26.3818 2.99779 26.1865 2.99957 25.9895V6.5105C2.99957 5.6765 3.68207 5 4.48757 5H31.5116C32.3336 5 32.9996 5.6735 32.9996 6.5105V25.9895C32.9996 26.8235 32.3171 27.5 31.5116 27.5H19.4996V27.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.665af1ab593654baa4a2cad3793cd08a.svg";
export { ForwardRef as ReactComponent };